import FileSaver from 'file-saver';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
    useDownloadTaxReturnPdf,
    useExportReportToExcel,
    useExportReportToPDF,
    useExportTaxReturnListToExcel,
    useIsTaxReturnPdfAvailableHook,
} from '../api/report/report';
import { WhitePaperReportExportRequest } from '../model';
import { getExportFileNameBasedOnSelectedReports, printFile } from '../utils/ReportUtils';

export const useExportReports = () => {
    const [exportedReports, setExportedReports] = useState<WhitePaperReportExportRequest[]>();
    const { t } = useTranslation();

    const saveFileAndClearState = (data: Blob, fileExtension: string, isTaxReturnList?: boolean) => {
        FileSaver.saveAs(data, getExportFileNameBasedOnSelectedReports(exportedReports, fileExtension, t, isTaxReturnList));

        setExportedReports([]);
    };

    const { mutateAsync: exportToExcelMutation, isLoading: isExcelExportProcessing } = useExportReportToExcel({
        mutation: {
            onSuccess: (data: any) => {
                saveFileAndClearState(data as Blob, '.xlsx');
            },
        },
    });
    const { mutateAsync: exportTaxReturnListToExcelMutation, isLoading: isTaxRetunExcelExportProcessing } = useExportTaxReturnListToExcel({
        mutation: {
            onSuccess: (data: any) => {
                saveFileAndClearState(data as Blob, '.xlsx', true);
            },
        },
    });
    const { mutateAsync: exportToPdfMutation, isLoading: isPdfExportProcessing } = useExportReportToPDF({
        mutation: {
            onSuccess: (data: any) => {
                saveFileAndClearState(data as Blob, '.pdf');
            },
        },
    });
    const { mutateAsync: downloadTaxReturnPdfMutation } = useDownloadTaxReturnPdf();

    const downloadTaxReturnPdf = (batchProcessId: string, taxReturnName: string) => {
        downloadTaxReturnPdfMutation({ params: { batchProcessId } }).then((data) => {
            FileSaver.saveAs(data, `${taxReturnName}.pdf`);
        });
    };

    const printTaxReturnPdf = (batchProcessId: string) => {
        downloadTaxReturnPdfMutation({ params: { batchProcessId } }).then((data) => {
            printFile(data);
        });
    };

    const isTaxReturnPdfAvailable = useIsTaxReturnPdfAvailableHook();
    const isProcessing = isExcelExportProcessing || isPdfExportProcessing || isTaxRetunExcelExportProcessing;

    return {
        exportToExcelMutation,
        exportToPdfMutation,
        setExportedReports,
        exportTaxReturnListToExcelMutation,
        downloadTaxReturnPdf,
        printTaxReturnPdf,
        isTaxReturnPdfAvailable,
        isProcessing,
    };
};
